import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import Button from '@mui/material-next/Button';

export default function BotoesIni() {
    return (
            <>
                <Button variant="text" sx={{ fontFamily: 'sans-serif' }} href="https://credmarcha2023.cnm.org.br/" target="_blank">
                    <TextSnippetIcon /> Declarações XXIV Marcha
                </Button>
            </>
    );
}
